import type { IconName } from '@/components/Icon/iconMap';

/**
 * 資産のライフサイクル概念とアイコンの対応（単一の語彙）。
 *
 * 概念はデバイス固有ではないため、備品・車両など他の資産からも参照してよい。
 * ステータスバッジ / イベント（アクション）ボタン / ライフサイクルのカード・目次 /
 * アクティビティ履歴は、すべてこの語彙を参照する。
 * アイコンを変えるときはここだけを直す（他所にアイコン名を直書きしない）。
 *
 * 出典: Figma「021_Devices」— Event 一覧 (13237:70153) / Status (13237:77869)。
 * 色は参照側（Badge / SectionCard / Button）のデザイントークンに従うため、ここでは持たない。
 */
export const ASSET_LIFECYCLE_ICON = {
  /** 割当（人への割り当て） */
  assignment: 'UserRoundCheckIcon',
  /** 設置（拠点への配置） */
  placement: 'OriginalPlacementCheckIcon',
  /** 在庫・利用可能 */
  stock: 'Inventory',
  /** 調達・入庫 */
  procurement: 'Truck',
  /** 回収（アクション） */
  retrieval: 'Package',
  /** 入庫＆回収（ライフサイクルのセクション） */
  checkInAndRetrieval: 'CalendarCheck2Icon',
  /** 棚卸し */
  inventoryCheck: 'PackageCheck',
  /** 故障 */
  faulty: 'ConstructionIcon',
  /** 修理 */
  repair: 'WrenchIcon',
  /** 再整備 */
  refurbishment: 'Sparkles',
  /** 処分（運用終了 / End of Life） */
  decommission: 'ArrowRightToLineIcon',
  /** 管掌 */
  jurisdiction: 'CrownIcon',
  /** 所有 */
  ownership: 'HandHelpingIcon',
  /** 予定のキャンセル */
  scheduleCancel: 'XIcon',
  /** 注文（調達の前段） */
  ordered: 'PackagePlus',
  /** 復旧 */
  recovered: 'HeartPulseIcon',
  /** 削除 */
  deleted: 'Trash2Icon'
} as const satisfies Record<string, IconName>;